import { FC } from 'react';
import styled from '@emotion/styled';
import { Heading } from '@chakra-ui/react';
import { omitComponentProps } from '../utils/omitComponentProps';
import { primaryProps } from '../utils/primaryProps';

const Header3Styled = styled(
  omitComponentProps(Heading, ['primary']),
)`
  ${primaryProps};
`;
(Header3Styled as { defaultProps?: Record<string, unknown> }).defaultProps = {
  as: 'h3',
  fontSize: '3xl',
};
export const Header3: FC<any> = Header3Styled;
